export enum EOrgType {
    /// <summary>
    /// 默认：组织架构
    /// </summary>
    Default = 0,
    /// <summary>
    /// 项目组
    /// </summary>
    ProjectOrg = 10,
}